import { Yii } from "libraries/interfaces/Yii";

export class Wording {
    public readonly title: string = Yii.t('wui-shared-js', "Journal des incidents - Résultats");
    public readonly noResult: string = Yii.t('wui-shared-js', "Aucun résultat pour cette recherche");
    public readonly prev: string = Yii.t('wui-shared-js', 'Précédent');
    public readonly next: string = Yii.t('wui-shared-js', 'Suivant');
}
